// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperTopbar_root__3-5Y5"};